import { matchPath, useLocation, useParams } from 'react-router-dom'

type UIMode = 'setup' | 'run'

const runSections = [
  'run',
  'check-in',
  'judging',
  'awards',
  'reports',
  'entries',
  'entrants',
  'status',
]

export function modeForPath(pathname: string, showSlug?: string): UIMode {
  if (showSlug) {
    return runSections.some(section => matchPath(`/:showSlug/${section}/*`, pathname))
      ? 'run'
      : 'setup'
  }
  if (
    [
      'show-series',
      'shows',
      'organizations',
      'people',
      'clubs',
      'catalog',
      'admin',
      'account',
      'public',
      'print',
      'connect',
    ].some(prefix => matchPath(`/${prefix}/*`, pathname))
  )
    return 'setup'
  return runSections.some(
    section =>
      matchPath(`/${section}/*`, pathname) || matchPath(`/:showSlug/${section}/*`, pathname)
  )
    ? 'run'
    : 'setup'
}

export function useRunMode() {
  const { pathname } = useLocation()
  const { showSlug } = useParams()
  return { mode: modeForPath(pathname, showSlug) }
}

export type { UIMode }
